<div class="flex min-w-0 flex-1 flex-col">
  <!-- Slot for things like breadcrumbs -->
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [hideSearch]="true"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-emails-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('to') {
                <td mat-cell *matCellDef="let email">
                  {{ email.to }}
                </td>
              }
              @case ('tag') {
                <td mat-cell *matCellDef="let email">
                  <aura-simple-chip [text]="email.tag | emailTagDisplay" />
                </td>
              }
              @case ('status') {
                <td mat-cell *matCellDef="let email">
                  <aura-send-status-chip [status]="email.status" />
                </td>
              }
              @case ('action') {
                <td mat-cell *matCellDef="let email">
                  {{ email.action | emailActionDisplay }}
                </td>
              }
              @case ('sendDate') {
                <td mat-cell *matCellDef="let email">
                  {{ email.sendDate | luxonDate: 'dd/LL/yyyy HH:mm' }}
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let email">
                  {{ email.createdAt | luxonDate: 'humanize' }}
                </td>
              }
              @case ('updatedAt') {
                <td mat-cell *matCellDef="let email">
                  {{ email.updatedAt | luxonDate: 'humanize' }}
                </td>
              }
              @case ('context') {
                <td mat-cell *matCellDef="let email">
                  @if (email.context?.user) {
                    <button
                      [matTooltip]="'Utilisateur'"
                      [routerLink]="['/users', email.context.user._id]"
                      mat-button
                      class="link flex flex-row items-center"
                    >
                      <aura-avatar
                        [label]="$safeNavigationMigration(email.context.user.identity?.firstName)"
                        [srcImage]="$safeNavigationMigration(email.context.user.identity.avatar?.url)"
                        [size]="'xs'"
                      />

                      <div class="ml-2">
                        {{ $safeNavigationMigration(email.context.user.identity?.firstName) | titlecase }}
                        {{ $safeNavigationMigration(email.context.user.identity?.lastName) | titlecase }}
                      </div>
                    </button>
                  } @else if (email.context?.userRegistration) {
                    <button
                      [matTooltip]="'Inscription'"
                      [routerLink]="['/user-registrations', email.context.userRegistration._id]"
                      mat-button
                      class="link flex flex-row items-center text-gray-10"
                    >
                      {{
                        $safeNavigationMigration(email.context.userRegistration.identity?.firstName)
                          | titlecase
                      }}
                      {{
                        $safeNavigationMigration(email.context.userRegistration.identity?.lastName)
                          | titlecase
                      }}
                    </button>
                  } @else if (email.context?.betaRegistration) {
                    <button
                      [matTooltip]="'Inscription Bêta'"
                      [routerLink]="['/beta-registrations', email.context.betaRegistration._id]"
                      mat-button
                      class="link flex flex-row items-center text-gray-10"
                    >
                      {{ $safeNavigationMigration(email.context.betaRegistration?.firstName) | titlecase }}
                      {{ $safeNavigationMigration(email.context.betaRegistration?.lastName) | titlecase }}
                    </button>
                  }
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let email">
                  {{ email[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
